import { IGetContratosFinanceiroDropDownUseCase } from "../../../presentation/useCases/read/get_contratos_financeiro_drop_down_use_case";
import { DropDown } from "../../models/dropdown";
import { ICommonsRepository } from "../../repositories/commons_repository";

/**
 * GetContratosFinanceiroDropDownUseCase
 */

export class GetContratosFinanceiroDropDownUseCase implements IGetContratosFinanceiroDropDownUseCase {
  constructor(private readonly repository: ICommonsRepository) { }

  async getContratosFinanceiroDropDown(IdIndiceReajuste: number | null): Promise<DropDown[]> {
    return await this.repository.getContratosFinanceiroDropDown(IdIndiceReajuste);

  }
}
